var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeNotification } from '@madbox/react_redux_request_handling/dist/slices/snackbar_slice';
import { Button } from '@mui/material';
export function SnackbarStack() {
    var dispatch = useDispatch();
    var notifications = useSelector(function (store) { return store.snackbar.notifications || []; });
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var displayed = useRef([]);
    useEffect(function () {
        notifications.forEach(function (_a) {
            var key = _a.key, message = _a.message, _b = _a.options, options = _b === void 0 ? {} : _b;
            // do nothing if snackbar is already displayed
            if (displayed.current.includes(key))
                return;
            var dismissText = options.dismissText, snackOptions = __rest(options, ["dismissText"]);
            // display snackbar using notistack
            enqueueSnackbar(message, __assign(__assign({ key: key, action: dismissText
                    ? function (key) { return (_jsx(Button, __assign({ onClick: function () { return closeSnackbar(key); }, variant: "text", sx: { color: 'inherit' } }, { children: dismissText }), void 0)); }
                    : undefined }, snackOptions), { onClose: function (event, reason, myKey) {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey);
                    }
                }, onExited: function (event, myKey) {
                    // remove this snackbar from redux store
                    dispatch(removeNotification(myKey));
                    displayed.current = displayed.current.filter(function (k) { return k !== myKey; });
                } }));
            // keep track of snackbars that we've displayed
            displayed.current = __spreadArray(__spreadArray([], displayed.current, true), [key], false);
        });
    }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);
    return null;
}
